import $ from "jquery";

$(".js-smoothscroll").click(function() {
	const enableOffset = window.innerWidth > 991;

	if (
		document.location.pathname.replace(/^\//, "") ===
			this.pathname.replace(/^\//, "") &&
		document.location.hostname === this.hostname
	) {
		const $this = $(this);
		var $target = $(this.hash);
		$target = $target.length ? $target : $(`[name=${this.hash.slice(1)}]`);

		if ($target.length) {
			const position = $target.offset();
			var scroll = 0;

			if (position !== undefined) {
				scroll = position.top;
			}

			if ($this.data("scroll-offset") && enableOffset) {
				scroll += parseInt($this.data("scroll-offset"), 10);
			}

			var extraOffset = enableOffset ? -70 : -40;
			scroll += extraOffset;

			document.body.classList.remove("mobilenav-is-open");

			$("html,body").animate(
				{
					scrollTop: scroll
				},
				800
			);

			return false;
		}
	}
});
